import React from "react";
import "./PrimaryButton.css";

class PrimaryButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activateWithEnter: false,
    };
    this.button = React.createRef();

    this.handleOnKeyPress = this.handleOnKeyPress.bind(this);
  }

  componentDidMount() {
    if (this.props.activatePrimaryWithEnter) {
      this.setState({
        activateWithEnter: true,
      });
      document.addEventListener("keypress", this.handleOnKeyPress);
    } else {
      this.setState({
        activateWithEnter: false,
      });
    }
  }

  handleOnKeyPress(e) {
    if (e.keyCode === 13) {
      this.button.current.click();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keypress", this.handleOnKeyPress);
  }

  render() {
    if (this.state.activateWithEnter) {
      return (
        <div className="primary-button-container">
          <button
            ref={this.button}
            disabled={this.props.isDisabled}
            className="primary-button"
            onClick={this.props.handlePrimaryBtnOnClick}
          >
            <span className="primary-button-bar-1"></span>
            <span className="primary-button-bar-2"></span>
            <span>{this.props.primaryButtonText}</span>
          </button>
        </div>
      );
    } else {
      return (
        <div className="primary-button-container">
          <button
            disabled={this.props.isDisabled}
            className="primary-button"
            onClick={this.props.handlePrimaryBtnOnClick}
          >
            <span className="primary-button-bar-1"></span>
            <span className="primary-button-bar-2"></span>
            <span>{this.props.primaryButtonText}</span>
          </button>
        </div>
      );
    }
  }
}

export default PrimaryButton;
